import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <p className="footer-copyright">© Vassabi 2026</p>
    </footer>
  );
}